import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import beforeEach from './beforeEach'

Vue.use(VueRouter)

const router = new VueRouter({ routes, mode: 'history' })

router.beforeEach(beforeEach)

/* eslint-disable */
if (process.env.ENVIRONMENT === 'production') {
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-WDMJPHV');
  router.afterEach((transition) => {
    if (window.ga) window.ga('send', 'pageview', transition.fullPath)
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js